import { default as getHasSummary } from "./getHasSummary";
import { default as getHeadings } from "./getHeadings";
import { default as getSectionId } from "./sectionId";

export { getSectionId, getHeadings, getHasSummary };
